import { getHeliusRpcUrl } from "./solanaRpc";

export interface HeliusAssetInfo {
  pricePerToken: number | null;
  currency: string | null;
}

export async function fetchHeliusAssetPrice(mint: string): Promise<HeliusAssetInfo | null> {
  const url = getHeliusRpcUrl();
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: "get-asset",
        method: "getAsset",
        params: { id: mint }
      })
    });
    
    if (!res.ok) return null;
    const data = await res.json();
    const priceInfo = data?.result?.token_info?.price_info;
    if (!priceInfo) return null;
    
    return {
      pricePerToken: priceInfo.price_per_token || null,
      currency: priceInfo.currency || null
    };
  } catch {
    return null;
  }
}
